module.exports = __webpack_public_path__ + "static/media/front.0a2a3fdc.png";